import { axiosInstanceWithoutLoader } from "@/use/utilities/axios/app/axios-instance-without-loader";

function getErrorMessage(error, fallbackMessage) {
  const backendMessage = error.response?.data?.message;
  if (backendMessage) {
    return backendMessage;
  }

  const backendErrors = error.response?.data?.errors;
  if (Array.isArray(backendErrors) && backendErrors.length > 0) {
    return backendErrors.join(", ");
  }

  if (typeof backendErrors === "string" && backendErrors.length > 0) {
    return backendErrors;
  }

  return fallbackMessage;
}

/**
 * Create a new conformity document for a prescription
 * @param {string|number} prescriptionId - The prescription ID
 * @param {Object} options - Options for document creation
 * @param {string} [options.shipped_at] - Optional shipping date in ISO format, defaults to current date
 * @returns {Promise<Object>} - The created document details
 * @throws {Error} - Throws error for validation errors, conflicts, or other API errors
 */
export async function create(prescriptionId, options = {}) {
  const axios = axiosInstanceWithoutLoader().primoLab;

  try {
    const payload = {};
    
    if (options.shipped_at) {
      payload.shipped_at = options.shipped_at;
    }

    const response = await axios.post(`/conformity-documents/${prescriptionId}`, payload);
    
    return {
      document: response.data.data || response.data,
      success: true
    };
  } catch (error) {
    if (error.response?.status === 409) {
      return {
        document: null,
        success: false,
        conflict: true,
        message: getErrorMessage(error, "La dichiarazione del fabbricante esiste già per questa prescrizione")
      };
    }
    
    if (error.response?.status === 400) {
      throw new Error(getErrorMessage(error, "Errore di validazione"));
    }
    
    throw new Error(getErrorMessage(error, "Si è verificato un errore nella creazione del documento"));
  }
}